import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import { ranks } from 'helpers/UserRank';
import { MEDIUM_STEPS, HIGH_STEPS } from 'constants/Steps';

import SvgIcon from 'components/SvgIcon/SvgIcon';
import styles from '../Onboarding.module.scss';

const NEXT_TIER = {
  [ranks.LOW_RANK]: { steps: MEDIUM_STEPS, label: 'Medium' },
  [ranks.MEDIUM_RANK]: { steps: HIGH_STEPS, label: 'High' },
};

const UserRankSteps = ({ user, currentRank }) => {
  const tier = NEXT_TIER[currentRank];

  if (!tier) {
    return <span />;
  }

  const { steps, label } = tier;
  const remaining = steps.filter((step) => !step.isComplete(user)).length;

  return (
    <div className={styles.rankStepsContainer}>
      <div className={styles.rankStepsHeader}>
        <span className={styles.rankStepsTitle}>Steps to reach {label}</span>
        <span className={styles.rankStepsRemaining}>{remaining} left</span>
      </div>

      {steps.map((step, index) => {
        const isComplete = step.isComplete(user);
        const stepLabel =
          typeof step.label === 'function' ? step.label(user) : step.label;

        return (
          <a
            key={index}
            className={classNames(
              styles.rankStepContainer,
              isComplete ? styles.rankStepComplete : undefined
            )}
            href={
              step.redir.startsWith('?')
                ? user.links.main_relative + step.redir
                : step.redir
            }
          >
            <span
              className={classNames(
                styles.rankStepCircle,
                isComplete ? styles.rankStepCircleComplete : undefined
              )}
            >
              {isComplete && <SvgIcon icon="tick" color="#ffffff" size="12" />}
            </span>

            <span
              className={classNames(
                styles.rankStepLabel,
                isComplete ? styles.completedLabel : undefined
              )}
            >
              {stepLabel}
            </span>
          </a>
        );
      })}
    </div>
  );
};

UserRankSteps.propTypes = {
  user: PropTypes.object,
  currentRank: PropTypes.number,
};

export default UserRankSteps;
